// src/frontend.js
import ReactDOM from "react-dom";
import CheckoutFieldsManager from "./CheckoutFieldsManager";
// import CheckoutStatusWatcher from "./CheckoutStatusWatcher";

import "./frontend.scss";

import logDebug from "./extraFunction.js";



const initializeReactComponents = () => {
  console.timeEnd('myCode');
  // debugger;
  if (document.getElementById("saphali-react-root")) {
    logDebug("React components already initialized");
    return;
  }
  logDebug("Initializing React components");

  

  const reactRoot = document.createElement("div");
  reactRoot.id = "saphali-react-root";
  document.body.appendChild(reactRoot);

  const config = window.saphaliSettingsFrontend || {
    hideFields: {},
    checkout_fields: {},
    onlyDate: "",
    position_in_contacts: "1",
  };

  ReactDOM.render(
    <>
      {/* <CheckoutStatusWatcher /> */}
      <CheckoutFieldsManager config={config} />
    </>,
    reactRoot
  );

  logDebug("React components initialized");
};
const waitForField = (selector, callback) => {
  const observer = new MutationObserver(() => {
      const element = document.querySelector(selector);
      if (element) {
          observer.disconnect();
          console.log(`Элемент ${selector} найден, инициализируем React...`);
          callback();
      }
  });

  observer.observe(document.querySelector('.wp-block-woocommerce-checkout'), { childList: true, subtree: true });
};
document.addEventListener("DOMContentLoaded", () => {
  if(typeof window.wc !== 'object') {console.warn("typeof window.wc !== 'object'"); return;}
  console.time('myCode');
  waitForField(".wc-block-checkout__shipping-fields, .wc-block-checkout__billing-fields", () => {
    initializeReactComponents();
  });
});
// document.addEventListener("DOMContentLoaded", () => {
//   debounce(initializeReactComponents, 1200)();
// });
